import React from 'react';
import { ButtonsPanel } from '@cp/ds/src/components/buttonsPanel';
import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { CatalogItemActions } from 'src/widgets/catalog/item/actions';
import { SpecialistRegistrationButton } from 'src/features/auth';
import { BottomBarProps } from './model';

export const BottomBar: React.FC<BottomBarProps> = ({ careerId, catalogType, id }) => {
  const loggedIn = useIsLoggedIn();
  return (
    <ButtonsPanel position="bottom-fixed">
      <Container>
        <CatalogItemActions catalogType={catalogType} id={id} />
        {careerId && !loggedIn ? (
          <Stack alignItems="center" sx={{ mt: 1 }}>
            <SpecialistRegistrationButton careerId={careerId} color="gray" size="normal" sx={{ pt: 1.5 }} variant="text" />
          </Stack>
        ) : null}
      </Container>
    </ButtonsPanel>
  );
};
